<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class=" rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">roundedImage_on_cards</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full">
          <div>
            <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">image_url</p>
                <input v-model="fieldJsonData.image_url"
                :class="image_url_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="image_url"
                >
                <p v-if="image_url_err" class="text-error heading-6">image_url is required</p>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">image_alt</p>
                <input v-model="fieldJsonData.image_alt"
                :class="image_alt_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="image_alt"
                >
                <p v-if="image_alt_err" class="text-error heading-6">image_alt is required</p>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">img_group_slug</p>
                <input v-model="fieldJsonData.img_group_slug"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="img_group_slug"
                >
              </div>
            </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">section_cards_list</p>
           <div v-for="(data, index) in fieldJsonData.section_cards_list" :key="index" class="pb-0 grid grid-cols-12">
                <div class="box col-span-12 p-2 pb-0">
                    <p class="label_css">heading</p>
                    <textarea v-model="data.heading"
                    :class="errorArray[index].heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    ></textarea>
                    <p v-if="errorArray[index].heading_err" class="text-error heading-6">heading is required</p>
                </div>
                <div v-if="tempCardDescriptionIndex !== index" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <label class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openCardListDescription(index)">{{componentDetailsForEdit !== null ? "+ Edit Description" : "+ Add Description"}}</label>
                <p v-if="componentDetailsForEdit !== null" v-html="data.description"></p>
                <p v-if="errorArray[index].description_err" class="text-error heading-6">description is required</p>
                </div>
                <div v-if="tempCardDescriptionIndex === index && cardDescriptionEditor === false" class="box col-span-12 p-2 pb-0">
                    <p class="label_css">description</p>
                    <editor v-model="data.description"
                    :class="errorArray[index].description_err ? 'border border-error' : ''"
                    placeholder="description"
                    ></editor>
                    <p v-if="errorArray[index].description_err" class="text-error heading-6">description is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_url</p>
                    <input v-model="data.img_url"
                    :class="errorArray[index].img_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_url"
                    >
                    <p v-if="errorArray[index].img_url_err" class="text-error heading-6">img_url is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_alt</p>
                    <input v-model="data.img_alt"
                    :class="errorArray[index].img_alt_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_alt"
                    >
                    <p v-if="errorArray[index].img_alt_err" class="text-error heading-6">img_alt is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">card_inner_img_background_color</p>
                    <input v-model="data.card_inner_img_background_color"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="card_inner_img_background_color"
                    >
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">redirect_to</p>
                    <input v-model="data.redirect_to"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="redirect_to"
                    >
                </div>
                <div class="col-span-12 mt-2 p-2 pb-0">
                    <p class="label_css">cta_in_new_tab</p>
                    <div class="flex items-center pb-1 ">
                    <input :id="`default-radio-3-${index}`" v-model="data.cta_in_new_tab" type="radio" :value="false" :name="`default-radio-3-${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-3-${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">No</label>
                    </div>
                    <div class="flex items-center pb-1 col-span-6">
                    <input :id="`default-radio-4-${index}`" v-model="data.cta_in_new_tab" type="radio" :value="true" :name="`default-radio-4-${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-4-${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">Yes</label>
                    </div>
               </div>
                <div v-if="fieldJsonData.section_cards_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
                    <div  class="mt-4" style="border: 1px solid gray"></div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">bottom_section</p>
           <div class="pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">heading</p>
                    <textarea v-model="fieldJsonData.heading"
                    :class="fieldJsonData.heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    ></textarea>
                    <p v-if="fieldJsonData.heading_err" class="text-error heading-6">heading is required</p>
                </div>
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">description</p>
                    <textarea v-model="fieldJsonData.description"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="description"
                    ></textarea>
                </div> -->
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">cta_text</p>
                    <input v-model="fieldJsonData.cta_text"
                    :class="fieldJsonData.cta_text_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="cta_text"
                    >
                    <p v-if="fieldJsonData.cta_text_err" class="text-error heading-6">cta_text is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">cta_url</p>
                    <input v-model="fieldJsonData.cta_url"
                    :class="fieldJsonData.cta_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="cta_url"
                    >
                    <p v-if="fieldJsonData.cta_url_err" class="text-error heading-6">cta_url is required</p>
                </div>
                <div class="col-span-12 mt-2 p-2 pb-0">
                    <p class="label_css">cta_in_new_tab</p>
                    <div class="flex items-center pb-1 ">
                    <input :id="`default-radio-3`" v-model="fieldJsonData.cta_in_new_tab" type="radio" :value="false" :name="`default-radio-3`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-3`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">No</label>
                    </div>
                    <div class="flex items-center pb-1 col-span-6">
                    <input :id="`default-radio-4`" v-model="fieldJsonData.cta_in_new_tab" type="radio" :value="true" :name="`default-radio-4`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-4`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">Yes</label>
                    </div>
               </div>
             </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
import Editor from '../../../../../../components/editor.vue'
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Editor
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      image_url_err: false,
      image_alt_err: false,
      isError: true,
      cardDescriptionEditor: false,
      tempCardDescriptionIndex: null,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   image_url: "",
      //   image_alt: "",
      //   img_group_slug: "",
      //   section_cards_list: [
      //       {
      //       card_inner_img_background_color: null,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       cta_in_new_tab: false,
      //       redirect_to: null
      //       },
      //       {
      //       card_inner_img_background_color: null,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       cta_in_new_tab: false,
      //       redirect_to: null
      //       },
      //       {
      //       card_inner_img_background_color: null,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       cta_in_new_tab: false,
      //       redirect_to: null
      //       },
      //       {
      //       card_inner_img_background_color: null,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       cta_in_new_tab: false,
      //       redirect_to: null
      //       },
      //       {
      //       card_inner_img_background_color: null,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       img_alt: "",
      //       img_alt_err: false,
      //       cta_in_new_tab: false,
      //       redirect_to: null  
      //       }
      //   ],
      //   bottom_section: {
      //       cta_in_new_tab: false,
      //       cta_text: "",
      //       cta_text_err: false,
      //       cta_url: "",
      //       cta_url_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //   }
      // }
      errorArray: [
        {
          heading_err: false,
          description_err: false,
          img_url_err: false,
          img_alt_err: false
        },
        {
          heading_err: false,
          description_err: false,
          img_url_err: false,
          img_alt_err: false
        },
        {
          heading_err: false,
          description_err: false,
          img_url_err: false,
          img_alt_err: false
        },
        {
          heading_err: false,
          description_err: false,
          img_url_err: false,
          img_alt_err: false
        },
        {
          heading_err: false,
          description_err: false,
          img_url_err: false,
          img_alt_err: false
        }
      ]
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
      for (let index = 0; index < this.fieldJsonData.section_cards_list.length; index++) {
        let obj = {
          heading_err: false,
          description_err: false,
          img_url_err: false,
          img_alt_err: false
        }
        this.errorArray.push(obj)
      }
    }
  },
  mounted () {
    this.$root.$on("callFormHandler",() => {
      this.saveData();
    })
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.image_url !== '') {
          this.image_url_err = false
          this.isError = false
        }
        if (this.fieldJsonData.image_alt !== '') {
          this.image_alt_err = false
          this.isError = false
        }
        if (this.fieldJsonData.heading !== '') {
            this.fieldJsonData.heading_err = false
            this.isError = false
        }
        if (this.fieldJsonData.cta_text !== '') {
          this.fieldJsonData.cta_text_err = false
          this.isError = false
        }
        if (this.fieldJsonData.cta_url !== '') {
          this.fieldJsonData.cta_url_err = false
          this.isError = false
        }
        for (let index = 0; index < this.fieldJsonData.section_cards_list.length; index++) {
          for (let i = 0; i < this.errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.section_cards_list[index].heading !== '') {
                this.errorArray[i].heading_err = false
                this.isError = false
              }
              if (this.fieldJsonData.section_cards_list[index].description !== '') {
                this.errorArray[i].description_err = false
                this.isError = false
              }
              if (this.fieldJsonData.section_cards_list[index].img_url !== '') {
                this.errorArray[i].img_url_err = false
                this.isError = false
              }
              if (this.fieldJsonData.section_cards_list[index].img_alt !== '') {
                this.errorArray[i].img_alt_err = false
                this.isError = false
              }
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    openCardListDescription (index) {
      this.tempCardDescriptionIndex = index
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      if (this.fieldJsonData.image_url === '') {
        this.image_url_err = true
        this.isError = true
      }
      if (this.fieldJsonData.image_alt === '') {
        this.image_alt_err = true
        this.isError = true
      }
      for (let index = 0; index < this.fieldJsonData.section_cards_list.length; index++) {
        for (let i = 0; i < this.errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.section_cards_list[index].heading === '') {
                this.errorArray[i].heading_err = true
                this.isError = true
              }
              if (this.fieldJsonData.section_cards_list[index].description === '') {
                this.errorArray[i].description_err = true
                this.isError = true
              }
              if (this.fieldJsonData.section_cards_list[index].img_url === '') {
                this.errorArray[i].img_url_err = true
                this.isError = true
              }
              if (this.fieldJsonData.section_cards_list[index].img_alt === '') {
                this.errorArray[i].img_alt_err = true
                this.isError = true
              }
            }
        }
      }
      if (this.fieldJsonData.heading === '') {
        this.fieldJsonData.heading_err = true
        this.isError = true
      }
      if (this.fieldJsonData.cta_text === '') {
        this.fieldJsonData.cta_text_err = true
        this.isError = true
      }
      if (this.fieldJsonData.cta_url === '') {
        this.fieldJsonData.cta_url_err = true
        this.isError = true
      }
      if (this.isError === false) {
        // for (let index = 0; index < this.fieldJsonData.section_cards_list.length; index++) {
        //     delete this.fieldJsonData.section_cards_list[index].heading_err
        //     delete this.fieldJsonData.section_cards_list[index].img_url_err
        //     delete this.fieldJsonData.section_cards_list[index].img_alt_err
        //     delete this.fieldJsonData.section_cards_list[index].description_err
        // }
        delete this.fieldJsonData.heading_err
        delete this.fieldJsonData.cta_text_err
        delete this.fieldJsonData.cta_url_err
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
      this.$root.$emit('closeComponentDialog', true)
    }
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>